import Flex from '@blocks/Flex'
import { desktop, tablet } from '@styles/mixins'
import React from 'react'
import styled, { css } from 'styled-components'
import { useSalonContext } from '../../context'
import SalonActionsByType from './components/ActionsByType'
import SalonStatusByType from './components/StatusByType'
import SalonUnavailable from './components/Unavailable'

export default function SalonHeader() {
    const { salon } = useSalonContext()

    if (salon.state.status === "unavailable")
        return <SalonUnavailable />

    return (
        <SalonHeaderWrapper>
            <SalonActionsByType />
            <SalonStatusByType />
        </SalonHeaderWrapper>
    )
}

// STYLES
const SalonHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    > div:not(:last-child) {
        margin-bottom: 10px;
    }

    ${desktop(css`
        align-items: center;
        flex-direction: row;
        justify-content: space-between;

        > div:not(:last-child) {
            margin-bottom: 0;
        }
    `)}
`